import React, {Component} from 'react';
import '../../../asset/style/workflow/tab-pane.css'
import Field100xImage from "./field100ximage";
import {Grid, IconButton, Stack, Typography} from "@mui/material";
import {ArrowCircleLeftTwoTone, ArrowCircleRightTwoTone} from "@mui/icons-material";
import {LoadingText} from "./components";
import {debounce, isNull, notNull} from "../../../utils/utils";

class AnnotationsPaginatedGrid extends Component {

	constructor(props) {
		super(props);

		this.state = this.initState();
	}

	componentDidMount() {
		this.debounceFunc = debounce(this.resizeListener, 400)
		window.addEventListener("resize", this.debounceFunc);
		document.addEventListener("keydown", this.keyDownListener);
	}

	componentWillUnmount() {
		document.removeEventListener("keydown", this.keyDownListener);
		window.removeEventListener("resize", this.debounceFunc);
	}

	componentDidUpdate = (prevProps) => {
		if (prevProps.annotations !== this.props.annotations || prevProps.row !== this.props.row ||
			prevProps.col !== this.props.col) {
			this.setState(this.initState());
			if (notNull(this.props.annotations) && this.props.annotations.length > 0)
				this.props.onSelect(this.props.annotations[0]);
		}
		if (prevProps.markedAnnotation !== this.props.markedAnnotation) {
			if (isNull(this.props.annotations) || this.props.annotations.length === 0) return;
			let page = Math.floor(this.props.annotations.indexOf(this.props.markedAnnotation) / this.gridsPerPage) + 1;
			if (page > 0 && page !== this.state.page)
				this.setState({
					page: page,
				});
		}
	}

	initState = () => {
		this.row = this.props.row || 1;
		this.col = this.props.col || 1;
		this.gridsPerPage = this.props.row * this.props.col;
		this.totalPages = Math.ceil((this.props.annotations || []).length / this.gridsPerPage);
		return ({
			page: 1,
		});
	}

	isSafeIndex = index => index >= 0 && index < this.props.annotations.length;

	keyDownListener = (event) => {
		if (event.target.tagName === 'INPUT' || event.ctrlKey || event.altKey)
			return;
		let index;
		switch (event.key) {
			case 'ArrowLeft':
				index = this.props.annotations.indexOf(this.props.markedAnnotation) - 1;
				break;
			case 'ArrowRight':
				index = this.props.annotations.indexOf(this.props.markedAnnotation) + 1;
				break;
			case 'ArrowUp':
				index = this.props.annotations.indexOf(this.props.markedAnnotation) - this.col;
				break;
			case 'ArrowDown':
				index = this.props.annotations.indexOf(this.props.markedAnnotation) + this.col;
				break;
			default:
				return;
		}
		if (this.isSafeIndex(index))
			this.props.onSelect(this.props.annotations[index]);
	}

	resizeListener = () => {
		this.forceUpdate()
	}

	paginate = () => {
		this.start = (this.state.page - 1) * this.gridsPerPage;
		this.end = this.start + this.gridsPerPage;
		this.annotations = (this.props.annotations || []).slice(this.start, this.end);
	};

	increasePage = () => this.setState({page: Math.min(this.totalPages, this.state.page + 1)});

	decreasePage = () => this.setState({page: Math.max(1, this.state.page - 1)});

	get100xgrid = () => {
		let height = `${100 / this.row}%`;
		let xs = 12 / this.col;
		return <Grid container height={"95%"} maxHeight={document.documentElement.clientHeight - 80}>
			{this.annotations.map(annotation =>
				<Grid item height={height} xs={xs} onTouchStart={() => this.props.onSelect(annotation)}
				      onClick={() => this.props.onSelect(annotation)}>
					<Field100xImage annotation={annotation} selected={this.props.markedAnnotation === annotation}
									cssfilter={this.props.cssfilter} scale={this.props.scale}/>
				</Grid>)}
		</Grid>
	}

	getPageNumber = () => this.totalPages > 0 ?
		<Stack className={'full-width'} direction={"row"} justifyContent={"space-evenly"} height={'5%'}
		       minHeight={'40px'}>
			<IconButton onClick={this.decreasePage} disabled={this.state.page === 1}>
				<ArrowCircleLeftTwoTone fontSize={"large"} sx={{color: 'cyan'}}/>
			</IconButton>
			{document.documentElement.clientWidth > 1200 ?
				<Typography alignSelf={"center"} variant={'h6'} color={"white"} overflow={'hidden'}>
					{this.start + 1}-
					{this.start + this.annotations.length} out of {this.props.annotations.length} 100x Fields
				</Typography> :
				<Typography alignSelf={"center"} variant={'body1'} color={"white"} overflow={'hidden'}>
					{this.start + 1}-{this.start + this.annotations.length} / {this.props.annotations.length}
				</Typography>

			}
			<IconButton onClick={this.increasePage} disabled={this.state.page === this.totalPages}>
				<ArrowCircleRightTwoTone fontSize={"large"} sx={{color: 'cyan'}}/>
			</IconButton>
		</Stack> : null;

	render() {

		if (isNull(this.props.annotations) || this.props.annotations.length === 0)
			return <LoadingText/>;

		this.paginate();
		return <Stack height={this.props.height || "100%"} width={'100%'} direction={"column"}
					  justifyContent={"space-between"} paddingX={'1%'}>
			{this.get100xgrid()}
			{this.getPageNumber()}
		</Stack>;
	}
}

export default AnnotationsPaginatedGrid;

